/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/LdapConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const LdapConfigCardTestIds = {
  bindPasswordRef: "bind-password-ref",
  btnCreateLdapConfig: "btn-create-ldap-config",
  btnEditLdapConfig: "btn-edit-ldap-config",
  cardTitleLdapConfig: "card-title-ldap-config",
  dlDirectoryDialect: "dl-directory-dialect",
  ldapConfigCard: "ldap-config-card",
  selectDirectoryDialect: "select-directory-dialect",
  dialectOption: (value: string) => `dialect-option-${value}`,
  dialectOptionPrefix: () => "dialect-option-" as TestIdPrefix
} as const;
